import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import * as fldExtract from "../../../Helpers/FieldExtractors"
import { ContainerType } from '../../../Models/Enum';
import { IMAGE_MAIN_ENDPOINT } from '../../../constant';



function DetailBannerCarousel(props) {

   var parsedDATA = props.data.data.ContentJson;

  var arrProductImages = fldExtract.getArraySorted_ZOrder(parsedDATA, 'FLD_1_4_5_5');




  return (

    <div>
      <Carousel data-bs-theme="dark" className='FruitDeatilHome mb-5 position-relative'>
        {arrProductImages != null && arrProductImages.map((item, index) => (
          <Carousel.Item key={index}>
            <img src={IMAGE_MAIN_ENDPOINT + (item.fileName) } className={"card-img-top rounded rounded-5 position-relative"} alt="..." />
               </Carousel.Item>


        ))
        }


      </Carousel>
      {parsedDATA.FLD_0_8_2_2 != undefined && parsedDATA.FLD_0_8_2_2 != null &&<div className="GITags position-absolute" ><img src="../../server-build/Images/GITaggedLabel1.png" /> <img src="../../server-build/Images/GITaggedLabel2.png" /></div>}
       
    </div>


  );
}

export default DetailBannerCarousel;